import React, { useContext } from 'react';
import StatusList from '../components/Status/StatusList';
import { MachineryStatusContext } from '../context/MachineryStatusContext';
import StatusListHeader from '../components/Status/StatusListHeader';
import './StatusPage.css';

function StatusPage() {
    const contextValue = useContext(MachineryStatusContext);
    const legacyData = Array.isArray(contextValue) ? contextValue : [];
    const {
        machineryData = legacyData,
    } = Array.isArray(contextValue) || !contextValue ? {} : contextValue;
    const mData = machineryData || [];

    // 통계 계산
    const stats = {
        total: mData.length,
        connected: mData.filter(m => m.connStatus === 1).length,
        disconnected: mData.filter(m => m.connStatus === 0).length,
        working: mData.filter(m => m.messageCode === 2).length,
        waiting: mData.filter(m => m.messageCode === 1).length,
        alarm: mData.filter(m => (m.messageCode >= 10) || (m.message && m.message.includes('ALARM'))).length
    };

    return (
        <div className="status-page-background">
            <div className="status-main-container">
                <div className="page-title-bar">
                    <h1>설 비 현 황</h1>
                </div>

                {/* 설비 상태 통계 대시보드 */}
                <div className="status-dashboard">
                    <div className="stat-item total">
                        <span className="stat-label">전체</span>
                        <span className="stat-value">{stats.total}</span>
                    </div>
                    <div className="stat-item connected">
                        <span className="stat-label">연결됨</span>
                        <span className="stat-value">{stats.connected}</span>
                    </div>
                    <div className="stat-item disconnected">
                        <span className="stat-label">연결끊김</span>
                        <span className="stat-value">{stats.disconnected}</span>
                    </div>
                    <div className="stat-item working">
                        <span className="stat-label">작업중</span>
                        <span className="stat-value">{stats.working}</span>
                    </div>
                    <div className="stat-item waiting">
                        <span className="stat-label">대기중</span>
                        <span className="stat-value">{stats.waiting}</span>
                    </div>
                    <div className="stat-item alarm">
                        <span className="stat-label">알람발생</span>
                        <span className="stat-value">{stats.alarm}</span>
                    </div>
                </div>
                
                <StatusListHeader />

                <div className="status-list-wrapper">
                    <StatusList machinery={mData || []} />
                </div>
            </div>
        </div>
    );
}

export default StatusPage;
